import { Injectable } from '@angular/core';

import { BaseService } from '../abstracts/base.service';
import { ResultModel } from '../models/result.model';
import { LessonModel } from '../models/lesson.model';
import { DocumentModel } from '../models/document.model';
import { DocumentUploadModel } from '../models/document-upload.model';
import { DocumentShareModel } from '../models/document-share.model';
import { SubjectModel } from '../models/subject.model';
import { StudentModel } from '../models/student.model';
import { ClassModel } from '../models/class.model';
import { SurveyParticipantModel } from '../models/survey/survey-participant.model';
import { AssessmentTemplateModel } from '../models/assessment-template.model';
import { TrainingModel } from '../models/training.model';
import { ExcelTemplateModel } from '../models/survey/excel-template.model';
import { ReportCommentModel } from '../models/survey/report-comment.model';
import { CompanyModel } from '../models/finance/company.model';
@Injectable({
  providedIn: 'root'
})
export class MediaService extends BaseService {

  /**
   * Document işlemleri
   */

   /**
    * Resim yükle
    * @param file 
    */
  uploadImage(file: File | Blob, fileName: string) {
    const uploadData = new FormData();
    uploadData.append('ImageFile', file, fileName);
    return this.httpClient.post<ResultModel<DocumentModel>>(this.getApiUrl('media/image-upload'), uploadData, { reportProgress: true, observe: 'events' });
  }
  
  get(documentID) {
    return this.httpClient.get<ResultModel<DocumentModel>>(this.getApiUrl('media/' + documentID));
  }

  update(document: DocumentModel) {
    return this.httpClient.put(this.getApiUrl('media'), document);
  }

  delete(documentID) {
    return this.httpClient.delete<ResultModel>(this.getApiUrl('media/' + documentID));
  }

  /**
   * Audio 
   */

  uploadAudio(file: File | Blob, fileName: string) {
    const uploadData = new FormData();
    uploadData.append('AudioFile', file, fileName);
    return this.httpClient.post<ResultModel<DocumentModel>>(this.getApiUrl('media/audio-upload'), uploadData, { reportProgress: true, observe: 'events' });
  }
  
  /**
   * Sınıf materyalleri
   */

  /**
    * Döküman yükle
    * @param documentModel 
    */
  uploadDocument(documentModel: DocumentUploadModel) {
    const uploadData = new FormData();

    if(documentModel.file){
      uploadData.append('File', documentModel.file, documentModel.file.name);
    }
    else if(!documentModel.pDocumentID){
      return;
    }

    var queryString = '';
    queryString = this.getQueryString(documentModel);

    if(queryString)
      queryString = '?' + queryString;

    return this.httpClient.post<ResultModel<DocumentModel>>(this.getApiUrl('media/document-share/document-upload' + queryString), uploadData, { reportProgress: true, observe: 'events' });
  }

  createDocumentShare(documentModel: DocumentShareModel) {
    return this.httpClient.post<ResultModel>(this.getApiUrl('media/document-share/material-upload'), documentModel);
  }
  
  updateClassMaterial(documentModel: DocumentShareModel[],classID:any) {
    return this.httpClient.post<ResultModel>(this.getApiUrl(`media/document-share/class-document-upload/${classID}`), documentModel);
  }
  updateClassSharedMaterial(surveyParticipant: SurveyParticipantModel[],classID:any) {
    return this.httpClient.post<ResultModel>(this.getApiUrl(`media/document-share/class-document-shared/${classID}`), surveyParticipant);
  }
  downloadSharedDocument(documentShareID){
    return this.httpClient.get<any>(this.getApiUrl('media/document-share/download/' + documentShareID));
  }

  downloadDocument(documentID){
    return this.httpClient.get<any>(this.getApiUrl('media/download/' + documentID));
  }

  listAll(formData: FormData){
    return this.httpClient.post<ResultModel>(this.getApiUrl('media/document-share/list'), formData);
      
  }

  listShareAll(formData: FormData, ClassID = null, TrainingID = null){
    
    var queryParams = {
      pClassID: ClassID,
      pTrainingID: TrainingID,
    }

    let queryString = this.getQueryString(queryParams);

    if(queryString){
      queryString = '?' + queryString;
    }

    return this.httpClient.post<ResultModel>(this.getApiUrl('media/document-share/listshare' + queryString), formData);
     
  }

  listShareStudentAll(formData: FormData ,TrainingID = null){
    
    var queryParams = {
      pTrainingID: TrainingID,
    }

    let queryString = this.getQueryString(queryParams);

    if(queryString){
      queryString = '?' + queryString;
    }

    return this.httpClient.post<ResultModel>(this.getApiUrl('media/document-share/list-student-share' + queryString), formData);
     
  }

  listAllDocument(formData: FormData, documentShareTypeID = null){
    
    var queryParams = {
      pDocumentShareTypeID: documentShareTypeID,
    }

    let queryString = this.getQueryString(queryParams);

    if(queryString){
      queryString = '?' + queryString;
    }

    return this.httpClient.post<ResultModel>(this.getApiUrl('media/document-share/listall' + queryString), formData);
     
  }

  listAllMyFilesForSelect(trainingID = null,studentID = null){
    var queryParams = {
      pTrainingID: trainingID,
      pStudentID: studentID,
    }

    let queryString = this.getQueryString(queryParams);

    if(queryString){
      queryString = '?' + queryString;
    }
    
    return this.httpClient.get<ResultModel>(this.getApiUrl('media/document-share/list-myfiles' + queryString));
  }
  getSharedDocument(documentShareID) {
    return this.httpClient.get<{DocumentShare: DocumentShareModel}>(this.getApiUrl('media/document-share/' + documentShareID));
  }

  updateSharedDocument(documentModel: DocumentShareModel) {
    return this.httpClient.post<ResultModel>(this.getApiUrl('media/document-share/update-document'), documentModel);
  }

  deleteSharedDocument(documentShareID) {
    return this.httpClient.delete<ResultModel>(this.getApiUrl('media/document-share/' + documentShareID));
  }

  deleteSharedDocumentForClass(documentShareID) {
    return this.httpClient.delete<ResultModel>(this.getApiUrl('media/document-share/class/' + documentShareID));
  }


  /**
   * Kullanıcının avatar resmini günceller
   * @param base64Image Avatar image
   */
  changeProfilePhoto(base64Image: string){
    var formData = new FormData;

    formData.append('img', base64Image);
    formData.append('format', 'PNG');

    return this.httpClient.post<ResultModel>(this.getApiUrl('media/change-avatar'), formData)
  }

  deleteProfilePhoto(){
    return this.httpClient.delete<ResultModel>(this.getApiUrl('media/delete-avatar'));
  }

  
  /**
  * Exam
  */

  /**
   * 
   * @param file 
   */
  uploadExamDocument(file: File) {
    const uploadData = new FormData();

    if(file){
      uploadData.append('File', file, file.name);
    }
    else {
      return;
    }

    return this.httpClient.post<ResultModel<DocumentModel>>(this.getApiUrl('media/exam/document-upload'), uploadData, { reportProgress: true, observe: 'events' });
  }

  getListMateryal(classID:any, trainingID:any) {
    return this.httpClient.get<ResultModel<DocumentShareModel[]>>(this.getApiUrl(`media/document-share/list-metaryal/${classID}/training/${trainingID}`));

  }

  getListMateryalForClass(classID:any, documentID:any) {
    return this.httpClient.get<ResultModel<SurveyParticipantModel[]>>(this.getApiUrl(`media/document-share/list-metaryal-class/${classID}/document/${documentID}`));

  }

  getMaterial(trainingID = null, documentShareTypeID = null, studentID = null, assessmentTemplateID = null) {
    var queryParams = {
      pTrainingID: trainingID,
      pDocumentShareTypeID: documentShareTypeID,
      pStudentID: studentID,
      pAssessmentTemplateID: assessmentTemplateID,
    }

    let queryString = this.getQueryString(queryParams);

    if(queryString){
      queryString = '?' + queryString;
    }
    return this.httpClient.get<ResultModel<any[]>>(this.getApiUrl('media/document-share/get-material' + queryString));
  }
  listAllNewForCard(pClassID: string, pListType: string) {
    return this.httpClient.get<{data:DocumentShareModel[],role:string,Class:ClassModel}>(this.getApiUrl(`media/document-share/list-card?pClassID=${pClassID}&pListType=${pListType}`));
  }
  getControl(pDocumentID:any,pDocumentShareTypeID:any,pTrainingID:any) {
    return this.httpClient.get<{Success:any,DocumentShare:DocumentShareModel,AssessmentDocumentShare:AssessmentTemplateModel}>(this.getApiUrl(`media/document-share/control/${pDocumentID}/${pDocumentShareTypeID}/${pTrainingID}`));
  }

  getReport(studentID = null, trainingID = null, documentShareTypeID = null, documentID = null, trainingTypeID = null) {
    var queryParams = {
      pStudentID: studentID,
      pTrainingID: trainingID,
      pDocumentShareTypeID: documentShareTypeID,
      pDocumentID: documentID,
      pTrainingTypeID: trainingTypeID
    }

    let queryString = this.getQueryString(queryParams);

    if(queryString){
      queryString = '?' + queryString;
    }
    return this.httpClient.get<{ Student: StudentModel, Document:any[] }>(this.getApiUrl('media/document-share/get-report' + queryString));
  }
  getReportInfo(studentID = null, trainingID = null) {
    var queryParams = {
      pStudentID: studentID,
      pTrainingID: trainingID
    }

    let queryString = this.getQueryString(queryParams);

    if(queryString){
      queryString = '?' + queryString;
    }
    return this.httpClient.get<{ Student: StudentModel,Training:TrainingModel,ExcelTemplate:ExcelTemplateModel,ReportComment:ReportCommentModel , Class:ClassModel}>(this.getApiUrl('media/document-share/get-report-info' + queryString));
  }
  getReportClassInfo(classID = null, trainingID = null) {
    var queryParams = {
      pClassID: classID,
      pTrainingID: trainingID
    }

    let queryString = this.getQueryString(queryParams);

    if(queryString){
      queryString = '?' + queryString;
    }
    return this.httpClient.get<{ Training:TrainingModel,ReportComment:ReportCommentModel,Class: ClassModel,ClassStudent:any,Company:CompanyModel }>(this.getApiUrl('media/document-share/get-report-class-info' + queryString));
  }

  getReportAllInfo(trainingID = null) {
    var queryParams = {
      pTrainingID: trainingID
    }

    let queryString = this.getQueryString(queryParams);

    if(queryString){
      queryString = '?' + queryString;
    }
    return this.httpClient.get<{ Training:TrainingModel,ReportComment:ReportCommentModel,ClassStudent:any,Company:CompanyModel }>(this.getApiUrl('media/document-share/get-report-all-info' + queryString));
  }

  getClassReport(classID = null, trainingID = null, documentShareTypeID = null) {
    var queryParams = {
      pClassID: classID,
      pTrainingID: trainingID,
      pDocumentShareTypeID: documentShareTypeID,
    }

    let queryString = this.getQueryString(queryParams);

    if(queryString){
      queryString = '?' + queryString;
    }
    return this.httpClient.get<{ Class: ClassModel,ClassStudent:any, Document:any[],ReportComment:ReportCommentModel }>(this.getApiUrl('media/document-share/get-classreport' + queryString));
  }

  getTrainingReport( trainingID = null, documentShareTypeID = null) {
    var queryParams = {
      pTrainingID: trainingID,
      pDocumentShareTypeID: documentShareTypeID,
    }

    let queryString = this.getQueryString(queryParams);

    if(queryString){
      queryString = '?' + queryString;
    }
    return this.httpClient.get<{ Training: TrainingModel,ClassStudent:any, Document:any[],ReportComment:ReportCommentModel }>(this.getApiUrl('media/document-share/get-trainingreport' + queryString));
  }

  listAllForSelect(params?: any) {
    var query = this.getQueryString(params);
    if(query)
      return this.httpClient.get<ResultModel<DocumentShareModel[]>>(this.getApiUrl(`media/document-share?${query}`));
    else
      return this.httpClient.get<ResultModel<DocumentShareModel[]>>(this.getApiUrl('media/document-share'));
  }
  
}
